import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; 
import { getFirestore } from "firebase/firestore"; 

const firebaseConfig = {
  apiKey: "AIzaSyCMgj8zjf8nZfDTEHCvuW0lEwr_B0bl2es",
  authDomain: "bee-s-care-quiz-app.firebaseapp.com",
  projectId: "bee-s-care-quiz-app",
  storageBucket: "bee-s-care-quiz-app.appspot.com",
  messagingSenderId: "409643571454",
  appId: "1:409643571454:web:4f544fa524d1ffdbc7edaf",
  measurementId: "G-SYTPL6ZG8L"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);